<script>
import {link , push} from 'svelte-spa-router'
import { _ } from "svelte-i18n";
import UserStore from '../stores/user';

export let activeLink;

// export let back_link = '/';
// export let hide_back = false;

let isMenuOpen = false;

function toggleMenu() {
  isMenuOpen = !isMenuOpen;
}

const logOut = ()=> {

  UserStore.update(user=>{
    return {};
  })

  push('/login');

}
</script>
  
<style>
  .header {
    background-color: #050A30;
    width: 200px;
    box-sizing: border-box;
    border-left: 1px solid #e4e4e4;

    background-color: #fff;
    border: 0;
    box-shadow: 0px 0px 13px #e1e1e1;
    box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
    z-index: 1;
  }
  .logo {
    display: flex;
    justify-content: center;  
    box-sizing: border-box;
    padding: 20px 40px 15px;
    font-size: 32px;;
    direction: ltr;
    gap:5px;

  }
  .logo span {
    font-family: 'Smooch Sans';
  }
  .logo i {    
    font-size: 32px;;
  }
  .logo i img {
    width: 30px;
    position: relative;
    margin-top:4px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding:20px;
  }
  a,.logout {
    /* color: #fff;; */
    text-decoration: none;
    display: block;
    padding:5px 0;
    font-size: 14px;;
    cursor: pointer;
  }
  .profile {
    color:#fff;
    padding:10px 20px;
    background-color: var(--blue-color);
    font-size: 14px;;

    /* color: #ca171e;
    background-color: #fff; */

    color: #fff;
    padding: 10px 20px;
    background-color: var(--blue-color);
    font-size: 14px;
    margin: 0 10px;
    border-radius: 70px;
    text-align: center;
  }
  .nav-links a {
    display: flex;
    align-items: center;
  }
  .nav-links img {
    position:relative;
    margin-left: 10px;;
    height: 20px;;   
    top:2px; 
  }
  .logout i {
    color: var(--blue-color);
    margin-left: 12px;;
  }
</style>

<div class="header">
  <!-- <div class="logo">
    <a href="/home" use:link><img src="images/logo.svg" class="logo"></a>    
  </div> -->

  
  <nav class="mobile-nav">
    <!-- <button class="hamburger" on:click={toggleMenu}>
      <span></span>
      <span></span>
      <span></span>
    </button>
    <div class="overlay" id="overlay" on:click={toggleMenu} class:active={isMenuOpen}></div> -->
    <div class="logo">
      <i><img src="images/ninja.svg"></i>
      <span>DropNinja</span>
    </div>
    <div class="profile">      
      <!-- <div>ברוך הבא</div> -->
      <div>{$UserStore.firstname} {$UserStore.lastname}</div>
      <div>{$UserStore.company}</div>
    </div>
    <div class="nav-links" id="nav-links" class:active={isMenuOpen}>
      <ul>
        <!-- <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/gettin.svg"></span><span>{$_('header.getting_started')}</span></a></li> -->
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/dash.svg"></span><span>{$_('header.dashboard')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/customers" use:link on:click={toggleMenu}><span><img src="images/customers.svg"></span><span>{$_('header.customers')}</span></a></li>
        <!-- <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/rewards.svg"></span><span>{$_('header.rewards')}</span></a></li> -->
        <li><a class:active-link="{activeLink === 'shipments'}" href="/orders" use:link on:click={toggleMenu}><span><img src="images/rewards.svg"></span><span>{$_('header.orders')}</span></a></li>

      </ul>

      <ul>
        <li><a class:active-link="{activeLink === 'products'}" href="/products" use:link on:click={toggleMenu}><span><img src="images/returns.svg"></span><span>{$_('header.products')}</span></a></li>
        <li><a class:active-link="{activeLink === 'my_products'}" href="/my_products" use:link on:click={toggleMenu}><span><img src="images/history.svg"></span><span>{$_('header.my_products')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/integrations" use:link on:click={toggleMenu}><span><img src="images/settings.svg"></span><span>{$_('header.integration')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/payments" use:link on:click={toggleMenu}><span><img src="images/rewards.svg"></span><span>{$_('header.payments')}</span></a></li>
      </ul>

      <ul>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/shipments" use:link on:click={toggleMenu}><span><img src="images/shipments.svg"></span><span>{$_('header.shipments')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/returns" use:link on:click={toggleMenu}><span><img src="images/returns.svg"></span><span>{$_('header.returns_replace')}</span></a></li>
        <!-- <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/history.svg"></span><span>{$_('header.shipping_history')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/settings.svg"></span><span>{$_('header.shipping_preferences')}</span></a></li> -->
      </ul>
      <!-- <ul>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/complaints.svg"></span><span>{$_('header.complaints')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/chat.svg"></span><span>{$_('header.live_chat')}</span></a></li>
      </ul> -->

      <ul>
        <li><span class="logout" on:click={logOut}><span><i class="fa-solid fa-arrow-right-from-bracket"></i></span><span>{$_('header.logout')}</span></span></li>
      </ul>

    </div>
  </nav>
</div>